import styled from "styled-components"


export const VentureImage = styled.img`
  object-fit: contain;  
  height: 100%;
`
